<template>
  <BaseChannelTimeSeries
    :title="title"
    :item-id="itemId"
    v-bind="$attrs"
  />
</template>

<script>
import BaseChannelTimeSeries from '@/components/cards/BaseChannelTimeSeries';

export default {
  name: 'ChannelInTimeChart',
  components: {
    BaseChannelTimeSeries,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>

